'use client';

export default function LoadUserComponent(): React.ReactNode {
  return null;
}
